import { IValidation, TBooleanInNumber } from 'src/types/main';

export const PickerType = {
  STATIC: 'static',
  LAZY: 'lazy',
} as const;
export type TPickerType = TValueOf<typeof PickerType>;

export const PickerPosition = {
  ABSOLUTE: 'absolute',
  FIXED: 'fixed',
  PORTAL: 'portal',
} as const;
export type TPickerPosition = TValueOf<typeof PickerPosition>;

export const PickerUnavailableType = {
  CATEGORY: 'category',
  PRODUCT_FOR_MEAL: 'productForMeal',
  POS_INT: 'posint',
} as const;
export type TPickerUnavailableType = TValueOf<typeof PickerUnavailableType>;

export interface IPickerOption {
  id?: number;
  label: string;
  value: any;
  //
  data?: any;
  //
  status?: TBooleanInNumber;
  out_of_stock?: TBooleanInNumber;
  warringText?: string;
  disabled?: boolean;
}

export interface IPickerValidation extends IValidation {
  errorBlockClassName?: string;
}

export interface IPickerProps<T> {
  type?: TPickerType;
  selectedOptions?: IPickerOption[];
  onSelect: (options: IPickerOption[]) => void;
  // configurations
  placeholder?: string;
  emptyPlaceHolder?: string;
  selectedItemsPlaceholder?: string;
  emptyText?: string;
  isMulti?: boolean;
  searchable?: boolean;
  hideResetIcon?: boolean;
  hideSelectedIcons?: boolean;
  noReset?: boolean;
  disabled?: boolean;
  loading?: boolean;
  position?: TPickerPosition;
  validation?: IPickerValidation;
  // unavailable configurations
  markUnavailable?: boolean;
  unavailableType?: TPickerUnavailableType;
  disableUnavailable?: boolean;
  // styles and classes
  className?: string;
  inputClassName?: string;
  defaultPlaceholderClassName?: string;
  optionClassName?: string;
  listClassName?: string;
  emptyListTextClassName?: string;
  numberVisibleOptionsInDropdown?: number;
  maxListWidth?: number;
  listPlacement?: 'top' | 'bottom';
  viewedType?: 'icon' | 'input';
  viewedSize?: 'small' | 'normal';
  // lazy pickers props
  fetchUrl?: string;
  fetchParams?: object;
  returnFullData?: (data: T[]) => void;
  autoFetch?: boolean;
  // static pickers props
  options?: IPickerOption[];
  propsOptions?: IPickerOption[];
  // others
  onTogglePicker?: (value: boolean) => void;
  notUsePlaceholderOnAllSelected?: boolean;
}
